import { Text, View } from 'react-native';
import { useState } from 'react';
import AuthPage, { AuthHeader, AuthInput as Input, AuthButton as SolidButton } from '@/components/General/AuthPage';
import { Keyboard } from 'react-native';
import Toast from 'react-native-toast-message'
import { supabase } from '@/data/client';
import { signOut } from '@/utils/signOut';
import { useRouter, useLocalSearchParams } from 'expo-router';
import { StyleSheet } from 'react-native-unistyles';


const DeleteAccountModal = () => {

    const [recoveryCode, setRecoveryCode] = useState("");

    const router = useRouter();
    const { recoveryEmail } = useLocalSearchParams();

    return (
        <AuthPage>
                <AuthHeader eyebrow="Account deletion" title="Before you go" description="Enter the code we sent to your email." />
        
                <View>
                    <Input
                        title="Confirmation Code"
                        textContentType="oneTimeCode"
                        autoComplete='one-time-code'
                        value={recoveryCode}
                        onUpdate={(new_value) => {
                            setRecoveryCode(new_value);
                        }}
                    />
                </View>
        
                <View style={{width:"100%", marginTop:20}}>
                    <SolidButton type="error" onPress={async () => {
                        Keyboard.dismiss();

                        const { error } = await supabase.auth.verifyOtp({ email: recoveryEmail, token: recoveryCode, type: 'email' })

                        if(!error){
                            const { deleteError } = await supabase.functions.invoke('disable-user');

                            if(deleteError){
                                Toast.show({type: 'error', text2: "Unable to delete your account, please try again."})
                            }
                            else{
                                Toast.delayShow({type: 'success', text2: "Your account has been successfully deleted."})
                                await signOut('global', 'account-deleted');
                                router.replace("/auth/login");
                            }
                        }
                        else{
                            Toast.show({type: 'error', text2: "It appears that the code you entered is incorrect or expired. Please double check, or go back and request a new one."})
                        }

                    }} text="Delete Reach Account" size="md"/>
                </View>

                <View style={{padding:20}}>
                    <Text style={styles.warningMessage}>This will permanently delete your Reach account. Your account will be de-registered from any organizations you are a part of. Any data given to each organization will be retained by them. To remove your data from an organization, contact the organization&apos;s admin.</Text>
                </View>
        </AuthPage>
    )
    
}

const styles = StyleSheet.create(({colors}) => ({
    warningMessage: {
        color:colors.textSecondary, 
        fontStyle:"italic", 
        textAlign:"center", 
        fontSize:12
    },
}))

export default DeleteAccountModal